"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
var Authentication_1 = require("../../../shared/Authentication");
var AuthenticationPopup_1 = require("../../../shared/AuthenticationPopup");
var container;
exports.insert = function (context, container) {
    react_dom_1.render(React.createElement(Authentication_1.Authentication, { context: context }), container);
};
exports.close = function () {
    if (!container) {
        return;
    }
    react_dom_1.unmountComponentAtNode(container);
    document.body.removeChild(container);
    container = undefined;
};
exports.open = function (context) {
    if (container) {
        return;
    }
    container = document.createElement('div');
    document.body.appendChild(container);
    react_dom_1.render(React.createElement(AuthenticationPopup_1.AuthenticationPopup, { context: context, onClose: exports.close }), container);
};



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/authentication/authentication.tsx
// module id = 237
// module chunks = 2